import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import './Home.css';

const expertises = [
  { title: 'Mécanique', desc: 'Révision, vidange, freinage, embrayage, distribution' },
  { title: 'Dépannage 7j/7', desc: 'Intervention rapide sur route, parking ou domicile' },
  { title: 'Achat / Vente Occasion', desc: 'Achat et vente de véhicules d\'occasion, toutes marques' },
  { title: 'Reprise Toutes Marques', desc: 'Reprise de votre ancien véhicule, estimation gratuite' },
  { title: 'Location de Voitures', desc: 'Location courte et longue durée, tarifs compétitifs' },
  { title: 'Carrosserie', desc: 'Réparation carrosserie, peinture, débosselage' },
  { title: 'Entretien & Réparation', desc: 'Entretien et réparation toutes marques, diagnostic complet' },
  { title: 'Recharge Climatisation', desc: 'Recharge et entretien de climatisation, contrôle du circuit frigorifique' },
];

const JOURS_ORDER = ['lundi','mardi','mercredi','jeudi','vendredi','samedi','dimanche'];
const JOURS_LABELS = { lundi:'Lundi', mardi:'Mardi', mercredi:'Mercredi', jeudi:'Jeudi', vendredi:'Vendredi', samedi:'Samedi', dimanche:'Dimanche' };

function formatHeure(h) {
  if (!h) return '';
  return h.slice(0, 5);
}

function formatDate(d) {
  if (!d) return '';
  return new Date(d).toLocaleDateString('fr-FR');
}

function Home() {
  const [services, setServices] = useState([]);
  const [horaires, setHoraires] = useState([]);
  const [vacances, setVacances] = useState(null);

  useEffect(() => {
    axios.get('/api/services/')
      .then(res => setServices(res.data.slice(0, 3)))
      .catch(err => console.error(err));
    axios.get('/api/horaires/')
      .then(res => {
        const sorted = [...res.data].sort((a, b) => JOURS_ORDER.indexOf(a.jour) - JOURS_ORDER.indexOf(b.jour));
        setHoraires(sorted);
      })
      .catch(err => console.error(err));
    axios.get('/api/vacances/')
      .then(res => setVacances(res.data))
      .catch(err => console.error(err));
  }, []);

  return (
    <div className="home">
      <Helmet>
        <title>Eagle Car's — Garage & Dépannage 24h/24 Haute-Savoie, Suisse, Ain</title>
        <meta name="description" content="Garage Eagle Car's à Étrembières (74100) — Dépannage 24h/24 7j/7 en Haute-Savoie, Ain et Suisse (Genève, Lausanne, Berne). Mécanique, carrosserie, achat-vente occasion, location. Intervention rapide partout." />
        <link rel="canonical" href="https://eaglecars.fr/" />
        <meta property="og:title" content="Eagle Car's — Garage & Dépannage 24h/24 Haute-Savoie, Suisse, Ain" />
        <meta property="og:description" content="Dépannage 24h/24 7j/7 en Haute-Savoie, Ain et Suisse. Intervention rapide partout." />
        <meta property="og:url" content="https://eaglecars.fr/" />
        <meta property="og:image" content="https://eaglecars.fr/og-image.jpg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
      </Helmet>

      {/* Hero */}
      <section className="hero">
        <div className="hero-bg-left" style={{backgroundImage:`url(${process.env.PUBLIC_URL}/images/hero-garage.jpg)`}} />
        <div className="hero-bg-right" style={{backgroundImage:`url(${process.env.PUBLIC_URL}/images/hero-depannage.png)`}} />
        <div className="hero-bg" />
        <div className="hero-split">

          {/* Gauche — Garage */}
          <div className="hero-side hero-side-left">
            <div className="hero-eyebrow">Votre garage</div>
            <h1>Garage<br /><em>Eagle Car's</em></h1>
            <p className="hero-desc">
              Achat, vente, mécanique, carrosserie et location. Toutes marques, au meilleur prix.
            </p>
            <Link to="/voitures" className="btn btn-outline">Nos Voitures</Link>
          </div>

          <div className="hero-divider" />

          {/* Droite — Dépannage */}
          <div className="hero-side hero-side-right">
            <div className="hero-eyebrow">Intervention rapide</div>
            <h1>Dépannage<br /><em>24h/24 · 7j/7</em></h1>
            <p className="hero-desc">
              Panne sur la route, batterie à plat, accident ? Nous intervenons rapidement où que vous soyez.
            </p>
            <a href="tel:+33676796771" className="btn btn-primary">Appeler maintenant</a>
          </div>

        </div>
      </section>

      {/* Dépannage — Zone d'intervention */}
      <section className="depannage-section">
        <div className="container">
          <div className="depannage-inner">
            <div className="depannage-text">
              <p className="hero-eyebrow">Intervention rapide</p>
              <h2 className="section-title">Dépannage <span>partout</span></h2>
              <div className="gold-line" />
              <p>
                Que vous soyez en panne sur l'autoroute, dans une rue de la ville ou en pleine campagne,
                Eagle Car's se déplace <strong>partout</strong> pour vous venir en aide, de jour comme de nuit,
                7 jours sur 7.
              </p>
              <p>
                Notre zone d'intervention couvre <strong>toute la région</strong> et s'étend jusqu'en
                <strong> Suisse</strong>. Aucune distance ne nous arrête quand il s'agit de vous
                sortir du problème rapidement et en toute sécurité.
              </p>
              <a href="tel:+33676796771" className="btn btn-primary" style={{ marginTop: 28, display: 'inline-flex' }}>
                Appeler maintenant
              </a>
            </div>
            <div className="depannage-cards">
              <div className="depannage-card">
                <h4>Panne moteur</h4>
                <p>Diagnostic et intervention sur place ou remorquage vers le garage</p>
              </div>
              <div className="depannage-card">
                <h4>Batterie à plat</h4>
                <p>Démarrage d'urgence ou remplacement de batterie en déplacement</p>
              </div>
              <div className="depannage-card">
                <h4>Accident</h4>
                <p>Prise en charge rapide et sécurisation du véhicule sur place</p>
              </div>
              <div className="depannage-card">
                <h4>Remorquage</h4>
                <p>Transport de votre véhicule vers notre garage ou l'adresse de votre choix</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Notre Garage */}
      <section className="home-garage-section">
        <div className="container home-garage-inner">
          <div className="home-garage-text">
            <h2 className="section-title">Notre <span>Garage</span></h2>
            <div className="gold-line" />
            <p>
              Le Garage Eagle Car's est votre spécialiste automobile toutes marques.
              Que vous cherchiez à acheter ou vendre un véhicule d'occasion, à faire
              entretenir votre voiture, ou à louer un véhicule, nous sommes là pour vous.
            </p>
            <p>
              Notre équipe qualifiée intervient en mécanique, carrosserie et dépannage
              7 jours sur 7, avec professionnalisme et transparence.
            </p>
          </div>
          <div className="depannage-horaires">
            <h3 className="depannage-horaires-title">Horaires d'ouverture</h3>
            {vacances?.en_vacances && (
              <div className="vacances-banner">
                Nous sommes en vacances du {formatDate(vacances.vacances_debut)} au {formatDate(vacances.vacances_fin)}
              </div>
            )}
            <div className="depannage-horaires-list">
              {horaires.map(h => (
                <div className={`dep-horaire-row${h.ferme ? ' ferme' : ''}`} key={h.jour}>
                  <span className="dep-jour">{JOURS_LABELS[h.jour]}</span>
                  {h.ferme ? (
                    <span className="dep-ferme">Fermé</span>
                  ) : (
                    <span className="dep-heures">
                      {formatHeure(h.ouverture_matin)} – {formatHeure(h.fermeture_matin)}
                      {h.ouverture_apres_midi && (
                        <> &nbsp;/&nbsp; {formatHeure(h.ouverture_apres_midi)} – {formatHeure(h.fermeture_apres_midi)}</>
                      )}
                    </span>
                  )}
                </div>
              ))}
              {horaires.length === 0 && !vacances?.en_vacances && (
                <p style={{ color: 'var(--gray)', fontSize: '0.9rem' }}>Chargement...</p>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Expertises */}
      <section className="expertises-section">
        <div className="expertises-inner">
          <div className="section-header centered">
            <p className="hero-eyebrow" style={{ marginBottom: 16 }}>Ce que nous faisons</p>
            <h2 className="section-title">Nos <span>Expertises</span></h2>
            <div className="gold-line centered" />
          </div>
          <div className="expertises-grid-2col">
            {expertises.map((e, i) => (
              <div className="expertise-card-glass" key={i}>
                <div className="expertise-number">0{i + 1}</div>
                <div className="expertise-content">
                  <h3>{e.title}</h3>
                  <p>{e.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Services Preview */}
      {services.length > 0 && (
        <section className="services-preview-section">
          <div className="services-preview-inner">
            <div className="section-header centered">
              <h2 className="section-title">Services <span>& Tarifs</span></h2>
              <div className="gold-line centered" />
            </div>
            <div className="services-preview-grid">
              {services.map(s => (
                <div className="service-preview-card" key={s.id}>
                  <h3>{s.name}</h3>
                  <p>{s.description}</p>
                  <span className="service-price">{s.price} €</span>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}


      {/* CTA */}
      <section className="cta-section">
        <div className="cta-inner">
          <h2>Besoin d'un devis ou d'un dépannage ?</h2>
          <p>Contactez-nous maintenant. Nous répondons rapidement et nous déplaçons partout.</p>
          <div className="cta-buttons">
            <a href="tel:+33676796771" className="btn btn-primary btn-large">Appeler maintenant</a>
            <Link to="/voitures" className="btn btn-outline btn-large">Voir nos voitures</Link>
          </div>
        </div>
      </section>

    </div>
  );
}

export default Home;
